import { render } from "./StudentAssign.vue?vue&type=template&id=59fb581e"
import script from "./StudentAssign.vue?vue&type=script&lang=js"
export * from "./StudentAssign.vue?vue&type=script&lang=js"

import "./StudentAssign.vue?vue&type=style&index=0&id=59fb581e&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__